module.exports = __webpack_public_path__ + "static/media/heart.9f458ef8.gif";